module.exports = __webpack_public_path__ + "assets/img/lvluoxinshu.dcb476f4.png";